module.exports = __webpack_public_path__ + "img/mv_search_pc.6dba1982.svg";